document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('.mobile-menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  if (menu && mobileNav) {
    menu.addEventListener('click', () => {
      const expanded = menu.getAttribute('aria-expanded') === 'true';
      menu.setAttribute('aria-expanded', String(!expanded));
      mobileNav.hidden = expanded;
    });
  }

  // Auto-save cart quantities using Shopify's own cart endpoint and recalculate discounts.
  document.querySelectorAll('[data-cart-auto-update]').forEach(form => {
    form.classList.add('cart-auto-ready');
    const quantities = [...form.querySelectorAll('[data-cart-quantity]')];
    const status = form.querySelector('[data-cart-update-status]');
    const checkout = form.querySelector('[name="checkout"]');
    let pendingTimer = null;
    let saving = false;
    const setStatus = (message, isError = false) => {
      if (!status) return;
      status.hidden = !message;
      status.textContent = message;
      status.classList.toggle('is-error', isError);
    };
    const save = async input => {
      if (saving) return;
      const quantity = Number(input.value);
      const line = Number(input.dataset.cartLine);
      if (!Number.isInteger(quantity) || quantity < 0 || !Number.isInteger(line) || line < 1) {
        setStatus('Enter a valid quantity of 0 or more.', true);
        return;
      }
      if (String(quantity) === input.dataset.savedQuantity) return;
      saving = true;
      quantities.forEach(field => field.disabled = true);
      if (checkout) checkout.disabled = true;
      setStatus('Updating your cart…');
      try {
        const path = (window.Shopify?.routes?.root || '/') + 'cart/change.js';
        const response = await fetch(path, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({line, quantity})
        });
        if (!response.ok) {
          let message = 'Could not update the cart. Please try again.';
          try { const result = await response.json(); message = result.description || result.message || message; } catch {}
          throw new Error(message);
        }
        window.location.reload();
      } catch (error) {
        saving = false;
        quantities.forEach(field => field.disabled = false);
        if (checkout) checkout.disabled = false;
        setStatus(error.message || 'Could not update the cart.', true);
      }
    };
    quantities.forEach(input => {
      input.dataset.savedQuantity = String(Number(input.value));
      input.addEventListener('input', () => {
        clearTimeout(pendingTimer);
        if (input.value.trim() === '') return;
        pendingTimer = setTimeout(() => save(input), 500);
      });
      input.addEventListener('change', () => {
        clearTimeout(pendingTimer);
        if (input.value.trim() !== '') save(input);
      });
    });
    form.addEventListener('submit', event => {
      if (saving || pendingTimer !== null) {
        event.preventDefault();
        clearTimeout(pendingTimer);
        pendingTimer = null;
        const dirty = quantities.find(field => field.dataset.savedQuantity !== String(Number(field.value)));
        if (dirty) save(dirty);
      }
    });
  });
  document.querySelectorAll('[data-product-root]').forEach(root => {
    const form = root.querySelector('.purchase-form');
    const addButton = root.querySelector('[data-add-to-cart]');
    const stickyButton = root.querySelector('[data-sticky-add]');
    const stickyBar = root.querySelector('.jolly-sticky-cart');
    const errorBox = root.querySelector('[data-cart-error]');
    const mainSelect = root.querySelector('[data-variant-select]');
    const gallery = root.querySelector('.product-media');
    const track = root.querySelector('[data-gallery-track]');
    const panels = [...root.querySelectorAll('.media-panel')];
    const thumbs = [...root.querySelectorAll('.thumb')];
    const dots = [...root.querySelectorAll('[data-gallery-dot]')];
    const promoVerified = root.dataset.verifiedBundleDiscounts === 'true';
    const currency = document.documentElement.dataset.currency || 'USD';
    const locale = document.documentElement.lang || 'en';
    const currencyText = cents => {
      try { return new Intl.NumberFormat(locale, {style:'currency', currency}).format(cents / 100); }
      catch { return (cents / 100).toFixed(2); }
    };
    const priceRate = qty => promoVerified ? Number(qty === 2 ? root.dataset.twoRate : qty === 3 ? root.dataset.threeRate : 100) : 100;
    const currentCard = () => root.querySelector('[data-offer-card].is-selected');
    const qtySelected = () => Number(root.querySelector('input[name="quantity"]:checked')?.value || 1);
    const mainVariant = () => {
      const choice = mainSelect?.selectedOptions[0];
      return {
        id: String(choice?.value || root.querySelector('[data-single-variant]')?.value || ''),
        price: Number(choice?.dataset.price ?? root.dataset.initialPrice ?? 0),
        compare: Number(choice?.dataset.variantCompare ?? root.dataset.initialCompare ?? 0),
        available: choice ? choice.dataset.available === 'true' : root.dataset.initialAvailable === 'true'
      };
    };
    const selectedVariants = () => {
      const card = currentCard();
      const selects = [...(card?.querySelectorAll('[data-bundle-variant]') || [])];
      if (selects.length) return selects.map(select => {
        const option = select.selectedOptions[0];
        return { id: String(option?.value || ''), price: Number(option?.dataset.price || 0), available: option?.dataset.available === 'true' };
      });
      const variant = mainVariant();
      return Array.from({length: qtySelected()}, () => ({...variant}));
    };
    let active = 0;
    function showMedia(index) {
      if (!panels.length) return;
      active = (index + panels.length) % panels.length;
      if (gallery?.classList.contains('gallery-peek')) {
        const selected = panels[active];
        track?.scrollTo({left: selected.offsetLeft - (track.clientWidth - selected.clientWidth) / 2, behavior: 'smooth'});
      } else if (gallery?.classList.contains('gallery-stacked')) {
        panels[active].scrollIntoView({behavior:'smooth',block:'nearest'});
      } else {
        panels.forEach((panel,i) => panel.classList.toggle('active', i === active));
      }
      thumbs.forEach((item,i) => item.classList.toggle('active', i === active));
      dots.forEach((item,i) => {
        item.classList.toggle('active', i === active);
        item.setAttribute('aria-current', String(i === active));
      });
    }
    const showVariantMedia = option => {
      const mediaId = option?.dataset.variantMediaId;
      const index = mediaId ? panels.findIndex(panel => panel.dataset.mediaId === mediaId) : -1;
      if (index !== -1) showMedia(index);
    };
    thumbs.forEach((item,i) => item.addEventListener('click', () => showMedia(i)));
    dots.forEach((item,i) => item.addEventListener('click', () => showMedia(i)));
    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showMedia(active-1));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => showMedia(active+1));
    if (root.dataset.gallerySwipe === 'true' && !gallery?.classList.contains('gallery-stacked') && !gallery?.classList.contains('gallery-peek')) {
      let startX = null;
      track?.addEventListener('touchstart', e => { startX = e.touches[0]?.clientX ?? null; }, {passive:true});
      track?.addEventListener('touchend', e => {
        if (startX === null) return;
        const difference = (e.changedTouches[0]?.clientX ?? startX) - startX;
        if (Math.abs(difference) > 45) showMedia(active + (difference < 0 ? 1 : -1));
        startX = null;
      }, {passive:true});
    }
    const addonState = () => {
      const card = currentCard();
      const protect = card?.querySelector('[data-card-protection]');
      const mystery = card?.querySelector('[data-card-mystery]');
      return {
        protect: !!protect?.checked && !protect.disabled && !!root.dataset.protectionVariant,
        mystery: !!mystery?.checked && !mystery.disabled && !!root.dataset.mysteryVariant
      };
    };
    function refresh() {
      const items = selectedVariants();
      const available = items.length > 0 && items.every(item => item.available && item.id);
      const qty = qtySelected();
      const base = items.reduce((sum,item) => sum + item.price, 0);
      const calculated = Math.round(base * priceRate(qty) / 100);
      const regularMain = mainVariant();
      const selectedCompare = Math.round(regularMain.price * Number(root.dataset.compareMarkup || 100) / 100);
      const first = root.querySelector('[data-mobile-product-price]');
      if (first) first.textContent = currencyText(regularMain.price);
      const firstCompare = root.querySelector('[data-first-compare-price]');
      if (firstCompare) {
        firstCompare.hidden = !selectedCompare;
        firstCompare.textContent = selectedCompare ? currencyText(selectedCompare) : '';
      }
      root.querySelectorAll('[data-quantity-price]').forEach(element => {
        const q = Number(element.dataset.quantityPrice);
        const card = root.querySelector('[data-offer-card][data-offer-qty="'+q+'"]');
        const selectors = [...(card?.querySelectorAll('[data-bundle-variant]') || [])];
        const sum = selectors.length ? selectors.reduce((n,s) => n + Number(s.selectedOptions[0]?.dataset.price || 0),0) : regularMain.price*q;
        element.textContent = currencyText(Math.round(sum * priceRate(q) / 100));
      });
      root.querySelectorAll('[data-compare-price]').forEach(element => {
        const q = Number(element.dataset.comparePrice);
        const card = root.querySelector('[data-offer-card][data-offer-qty="'+q+'"]');
        const selectors = [...(card?.querySelectorAll('[data-bundle-variant]') || [])];
        const sum = selectors.length ? selectors.reduce((n,s) => n + Number(s.selectedOptions[0]?.dataset.price || 0),0) : regularMain.price*q;
        element.hidden = q !== 1 && !promoVerified;
        element.textContent = q === 1 ? currencyText(Math.round(sum * Number(root.dataset.compareMarkup || 100) / 100)) : promoVerified ? currencyText(sum) : '';
      });
      const line = root.querySelector('[data-current-unit-price]');
      if (line) line.textContent = currencyText(calculated);
      const mainCompare = root.querySelector('[data-main-compare]');
      if (mainCompare) {
        mainCompare.hidden = !selectedCompare || qty !== 1;
        mainCompare.textContent = selectedCompare && qty === 1 ? currencyText(selectedCompare) : '';
      }
      const addons = addonState();
      const total = calculated + (addons.protect ? Number(root.dataset.protectionPrice||0) : 0) + (addons.mystery ? Number(root.dataset.mysteryPrice||0) : 0);
      const stickyPrice = root.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = currencyText(total);
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.soldLabel;
      }
      if (stickyButton) stickyButton.disabled = !available;
    }
    root.querySelectorAll('input[name="quantity"]').forEach(input => input.addEventListener('change', () => {
      root.querySelectorAll('[data-offer-card]').forEach(card => card.classList.toggle('is-selected', card.querySelector('input[name="quantity"]')?.checked || false));
      const option = currentCard()?.querySelector('[data-bundle-variant]')?.selectedOptions[0] || mainSelect?.selectedOptions[0];
      showVariantMedia(option);
      refresh();
    }));
    mainSelect?.addEventListener('change', () => {
      showVariantMedia(mainSelect.selectedOptions[0]);
      root.querySelectorAll('[data-variant-pick]').forEach(button => {
        const active = button.dataset.variantPick === mainSelect.value;
        button.classList.toggle('is-active',active);
        button.setAttribute('aria-pressed',String(active));
      });
      refresh();
    });
    root.querySelectorAll('[data-variant-pick]').forEach(button => button.addEventListener('click', () => {
      if (!mainSelect || button.disabled) return;
      mainSelect.value = button.dataset.variantPick;
      mainSelect.dispatchEvent(new Event('change',{bubbles:true}));
      const activeChoice = currentCard()?.querySelector('[data-bundle-variant]');
      if (activeChoice) {
        activeChoice.value = button.dataset.variantPick;
        activeChoice.dispatchEvent(new Event('change',{bubbles:true}));
      }
    }));
    root.querySelectorAll('[data-bundle-variant]').forEach(choice => choice.addEventListener('change', () => {
      const option = choice.selectedOptions[0];
      showVariantMedia(option);
      const preview = choice.closest('.jolly-variant-row')?.querySelector('.jolly-bundle-preview img');
      if (preview && option?.dataset.variantImage) {
        preview.src = option.dataset.variantImage;
        preview.srcset = '';
        preview.alt = option.textContent.trim();
      }
      refresh();
    }));
    root.querySelectorAll('[data-card-protection],[data-card-mystery]').forEach(box => box.addEventListener('change', refresh));
    stickyButton?.addEventListener('click', () => addButton?.click());
    if (stickyBar && addButton) {
      const observe = () => {
        const rect = addButton.getBoundingClientRect();
        const visible = rect.top < window.innerHeight && rect.bottom > 0;
        stickyBar.classList.toggle('is-visible', !visible && window.scrollY > 240);
      };
      window.addEventListener('scroll',observe,{passive:true});
      window.addEventListener('resize',observe,{passive:true});
      observe();
    }
    form?.addEventListener('submit', async event => {
      event.preventDefault();
      if (!addButton || addButton.disabled) return;
      const variants = selectedVariants();
      if (!variants.length || variants.some(v => !v.id || !v.available)) return;
      const counts = new Map();
      for (const variant of variants) counts.set(variant.id,(counts.get(variant.id)||0)+1);
      const items = [...counts.entries()].map(([id,quantity]) => ({id,quantity}));
      const addons = addonState();
      if (addons.protect) items.push({id: String(root.dataset.protectionVariant),quantity:1});
      if (addons.mystery) items.push({id: String(root.dataset.mysteryVariant),quantity:1});
      if (errorBox) {errorBox.hidden=true;errorBox.textContent='';}
      addButton.disabled=true;
      if (stickyButton) stickyButton.disabled=true;
      try {
        const base = window.Shopify?.routes?.root || '/';
        const response = await fetch(base+'cart/add.js',{
          method:'POST',
          credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items})
        });
        if (!response.ok) {
          let message='We could not add your selection. Please try again.';
          try {const result=await response.json(); message=result.description||result.message||message;} catch {}
          throw new Error(message);
        }
        window.location.assign(base+'cart');
      } catch (error) {
        if (errorBox) {errorBox.hidden=false;errorBox.textContent=error.message;}
        refresh();
      }
    });
    refresh();
    showVariantMedia(mainSelect?.selectedOptions[0] || currentCard()?.querySelector('[data-bundle-variant]')?.selectedOptions[0]);
  });
});